export default "__VITE_ASSET__CRTU0PVP__"